import api, { request } from '../../../../../../api';
import { IStateDispatchActions } from '../TeeSheetCreator.context';

export type IGetShotgunSpots = (
  clubId: number | string,
  eventId: number | string,
  roundId: number | string
) => Promise<void>;

export const getShotgunSpots: IStateDispatchActions<IGetShotgunSpots> = (_, dispatch) => async (
  clubId,
  eventId,
  roundId
) => {
  const response = await request.get(api.admin.roundShotgun(clubId, eventId, roundId));

  if (response) {
    dispatch({
      type: 'setShotgunSpots',
      value: response
    });
  }
};
